import { appendReduxPart } from "infrastructure/store";

import { accountsSaga } from "./Account.saga";
import { accounts } from "./Account.slice";

export * from "./Account.actions";
export * from "./Account.state";

appendReduxPart(
  {
    reducerName: accounts.name,
    reducer: accounts.reducer
  },
  accountsSaga()
);
